// extracted by mini-css-extract-plugin
export var textInput = "_gs-0";